// XXX: This needs to be rewritten as https://github.com/plone/mockup/blob/5.1.x/src/pat/markspeciallinks/markspeciallinks.js
import $ from "jquery";
import Base from "@patternslib/patternslib/src/core/base";

export default Base.extend({
    name: "cabq-markspeciallinks",
    trigger: ".pat-cabq-markspeciallinks",
    parser: "mockup",

    defaults: {},

    async init() {
        // first make external links open in a new window, afterwards do the
        // normal plone link wrapping in only the content area
        var url,
            protocols,
            contentarea,
            res;

        url = window.location.protocol + '//' + window.location.host;

        protocols = /^(mailto|ftp|news|irc|h323|sip|callto|https|feed|webcal)/;
        contentarea = $('#region-content,#content');

        // FD#296: Add a globe for external links
        var selector = 'a[href^="http"]';
        selector += ':not(.link-plain)'
        selector += ':not([href^="' + url + '"])'
        selector += ':not([href*="abclibrary.org"])'
        selector += ':not([href*="cabq.gov"])'

        contentarea.find(selector).each(function(index) {
            var origHref = $( this ).attr('href');

            $(this)
            .after(`<a href="${origHref}" class="extLinkGlobe"><i title="External Link Disclaimer" alt="External Link Disclaimer" role="img" class="fa fa-globe fa-fw"></i></a>`);
        })

        $('.extLinkGlobe').on('click', function(event) {
            const modal = $('#offsite-warning-dialog');
            const emailLink = $('#offsite-warning-dialog #questionsEmailLink');
            const cancelBtn = $('#offsite-warning-dialog .btn-modal.btn-cancel');
            const continueBtn = $('#offsite-warning-dialog .btn-modal.btn-continue');

            // grab the current focused element so we can set it back when modal is closed
            var prevFocused = $(document.activeElement);

            // Trap focus within modal div
            const KEYCODE_TAB = 9;
            const KEYCODE_ESC = 27;

            modal.keydown(function(e) {

                // set last focus if esc key pressed
                if(e.keyCode === KEYCODE_ESC) {
                    event.preventDefault();
                    modal.modal('hide');
                    cancelBtn.off();
                    prevFocused.focus();
                }
                // return everything else
                else if (e.keyCode !== KEYCODE_TAB) {
                return;
                }

                if ( e.shiftKey ) /* shift + tab */ {
                    if (emailLink.is(':focus')) { // email link is first link in modal
                        continueBtn.focus();
                        e.preventDefault();
                        }
                } else /* tab */ {
                    if (continueBtn.is(':focus')) { // continue button is last link modal
                        emailLink.focus();
                        e.preventDefault();
                        }
                }
            });

            // open a modal
            event.preventDefault();
            var $this = $(this);
            var url = $this.attr('href');
            $('#offsite-warning-dialog #offsite-warning-link-url').html(url);
            modal.modal('show');

            // Get the current focused element:
            modal.on('shown.bs.modal', function () {
                $('#cancelDialog').focus(); //force focus on first button
            })

            //go to link on modal close
            continueBtn.click(function() {
                window.open(url);
                continueBtn.off();
            });
            cancelBtn.click(function(event) {
                event.preventDefault();
                modal.modal('hide');
                cancelBtn.off();
                prevFocused.focus();
            });
        });

        // FD#296: Add a PDF icon for PDF links
        selector = 'a[href$=".pdf"]';

        contentarea.find(selector)
            .append('<a href="/about/pdf.html" class="link-pdf"></a>');

        // If Link is preceded with a pdf icon (such as when adding a pdf file object), remove it
        selector = 'a[href$=".pdf"]';
        selector += ' img[src="pdf.png"]'
        $(selector).remove()

        // All links without an http href (without the link-plain class), not within this site,
        // and no img children should be wrapped in a link-[protocol] span
        contentarea.find(
            'a[href]:not([href^="http"]):not(.link-plain):not([href^="' + url + '"]):not(:has(img)):not([href^="#"])')
            .each(function() {
                // those without a http link may have another interesting protocol
                // wrap these in a link-[protocol] span
                console.debug('marking special link', this.href);
                res = protocols.exec(this.href);
                if (res) {
                    $(this).wrap('<span></span>').parent().addClass('link-' + res[0]);
                }
            });
    },
});